import React, { useEffect, useState } from 'react';
import { fetchOnlineBooking, postFormData } from '../../../../modules/api';
import useParams from '../../../globalHooks/useParams';
import {
  initialPassengerValues,
  initialTravelDetailsValues,
  navList,
  passengerValidationSchema,
  travelDetailsValidationSchema,
} from '../utils';
import useHandleReCaptchaVerify from '../../../globalHooks/useHandleReCaptchaVerify';

const useOnlineBooking = () => {
  const { handleReCaptchaVerify } = useHandleReCaptchaVerify();

  const params = useParams();

  const [currentNav, setCurrentNav] = useState(navList[0]);

  const [data, setData] = useState(null);

  const [selectedDeparture, setSelectedDeparture] = useState(null);

  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  const [savedTravelDetails, setSavedTravelDetails] = useState(null);

  const [savedPassengers, setSavedPassengers] = useState(null);

  const [waiting, setWaiting] = useState(true);

  const nav = navList;

  // Get fields on load
  useEffect(() => {
    (async () => {
      const data = await fetchOnlineBooking(params?.hol);

      // const { departures, form, intro, id } = data;

      setData(data);

      setWaiting(false);
    })();
  }, []);

  const postForm = async (data, recaptchaToken, callback) => {
    if (!recaptchaToken || recaptchaToken.trim().length < 1) {
      alert('Please fill out the Recaptcha');
    } else {
      setWaiting(true);

      try {
        // const extraFields = {
        //   form_reference: 'contact',
        //   id: 'contact-form',
        //   tour: fields?.tour?.id,
        // };

        await postFormData({ ...data }, recaptchaToken);

        // if (submitInfo.type === 'page') {
        //   window.location.href = submitInfo.page;
        // } else {
        //   setShowSuccessDialog(true);
        // }

        if (callback) callback();
      } catch (error) {
        console.error(error);

        if (error.message === 'Invalid recaptcha response') {
          alert('Invalid recaptcha response');
        }
      }

      setWaiting(false);
    }
  };

  const disable = (errors, values, initialValues) => {
    const hasErrors = Object.keys(errors).length > 0;

    return (
      hasErrors || JSON.stringify(values) === JSON.stringify(initialValues)
    );
  };

  const forwardNav = (values) => {
    const foundObj = nav.find(({ slug: _slug }) => currentNav.slug === _slug);

    if (foundObj) {
      // save form
      if (values) {
        switch (foundObj.slug) {
          case 'travel-details':
            setSavedTravelDetails(values);
            break;
          case 'passengers':
            setSavedPassengers(values);
          // eslint-disable-next-line no-fallthrough
          default:
            break;
        }
      }

      const index = nav.indexOf(foundObj) + 1;

      if (nav[index]) {
        setCurrentNav(nav[index]);
        window.scrollTo(0, 0);
      } else throw Error(`Can't find nav element from ${currentNav.slug}`);
    } else throw Error(`Can't find nav element from ${currentNav.slug}`);
  };

  const backwardNav = () => {
    const foundObj = nav.find(({ slug: _slug }) => currentNav.slug === _slug);

    if (foundObj) {
      const index = nav.indexOf(foundObj) - 1;

      if (nav[index]) {
        setCurrentNav(nav[index]);
        window.scrollTo(0, 0);
      } else throw Error(`Can't find nav element from ${currentNav.slug}`);
    } else throw Error(`Can't find nav element from ${currentNav.slug}`);
  };

  return {
    waiting,
    departures: data?.departures,
    currentNav,
    setCurrentNav,
    intro: data?.intro,
    id: data?.id,
    form: data?.form,
    nav,
    initialTravelDetailsValues,
    initialPassengerValues,
    travelDetailsValidationSchema,
    passengerValidationSchema,
    handleReCaptchaVerify,
    showSuccessDialog,
    selectedDeparture,
    setSelectedDeparture,
    postForm,
    disable,
    forwardNav,
    backwardNav,
    savedTravelDetails,
    savedPassengers,
  };
};

export default useOnlineBooking;
